import get from "lodash/get";
import isEqual from "./customHelpers/isEqual";
import { projectBasePathWithFolder } from "../../config/apiEndpoints";
import LocalStorageFunc from "./localStorageFunc";
import store from "../../store/index";
// import store from "../store/payment";
import { keyMapsMutation } from "./../storeKeys";
import { MINIAPP, ORDER_TYPE } from "./paymentConstants";

// import getAmplitudeInstance from './amplitude/getAmplitudeInstance';
const randomnumber = (minimum = 100000000, maximum = 999999999) => {
  return Math.floor(Math.random() * (maximum - minimum, maximum + 1)) + minimum;
};

// const pizzaCounter = () => {
//   if (!!window.IntersectionObserver) {
//     let scrollY = window.scrollY;
//     let observer = new IntersectionObserver(
//       (entries, observer) => {
//         entries.forEach((entry) => {
//           if (window.scrollY <= scrollY && entry.isIntersecting) {
//             store.commit(
//               keyMapsMutation.SET_PRODUCT_COUNTER_STRING,
//               entry.target.id
//             );
//           } else if (window.scrollY > scrollY && !entry.isIntersecting) {
//             store.commit(
//               keyMapsMutation.SET_PRODUCT_COUNTER_STRING,
//               entry.target.id
//             );
//           }
//           scrollY = window.scrollY;
//         });
//       },
//       {
//         root: null,
//         threshold: 1,
//       }
//     );
//     store.commit(keyMapsMutation.SET_PRODUCT_OBSERVER, observer);
//   }
// };

const tryJsonParse = (value) => {
  let _ = {};
  try {
    _ = JSON.parse(value);
  } catch (e) {
    _ = {};
  }
  return _;
};

const calculateIsTrueLocationDetectedFromLocationSource = () => {
  return LocalStorageFunc.getLocationSource() == "ip" ? false : true;
};

const takeawayDineinFolder = (isTrueLocationDetected) => {
  if (isTrueLocationDetected) {
    return "nearestStore";
  }
  const takeawayLocation = getSessionStorageValue("takeawayLocation");
  if (typeof takeawayLocation != "undefined" && takeawayLocation)
    return "nearestStore";
  return "locationSelection";
};

const deliveryFolder = (isLoggedIn) => {
  if (isLoggedIn) {
    let userAddresses = localStorage.userAddresses
      ? tryJsonParse(localStorage.userAddresses)
      : "";
    if (Array.isArray(userAddresses) && userAddresses.length > 0)
      return "address";
  }
  return "changeAddress";
};

const textLowerAndTrimSpace = (text) =>
  text.toLocaleLowerCase().replace(/\s/g, "");

const keybasedProductItems = (productItems) => {
  let response = {};
  productItems.forEach((_) => {
    let temp1 = {};
    _.data?.forEach((__) => {
      let temp2 = {};
      __.data?.forEach((___) => {
        temp2[___.code] = ___;
      });
      temp1[__.categoryName] = { ...__, data: temp2 };
    });
    response = { ...response, ...temp1 };
  });
  return response;
};

const keybasedProductItem = (_) => {
  let response = {};
  let priceHashCode = {};
  _?.forEach((__) => {
    let temp2 = {};
    __.data?.forEach((___) => {
      temp2[___.code] = ___;
      priceHashCode[___.code] = {};
      temp2[___.code]["customCategoryId"] = __.categoryId;
      temp2[___.code]["customCategoryName"] = __.categoryName;

      temp2[___.code].crust?.map((c) => {
        priceHashCode[___.code][c.crustId] = {};
        c?.sizes.map((s) => {
          priceHashCode[___.code][c.crustId][s.sizeId] = s.price;
        });
      });

      if (!temp2[___.code]["defaultPrice"]) {
        temp2[___.code]["defaultPrice"] = +temp2[___.code].crust
          .filter((_) => {
            if (_.crustId == temp2[___.code].selectedCrustId) {
              temp2[___.code]["defaultCrustName"] = _.name;
              temp2[___.code]["crustName"] = _.name;
              temp2[___.code]["crustId"] = temp2[___.code].selectedCrustId;
            }
            return _.crustId == temp2[___.code].selectedCrustId;
          })[0]
          ?.sizes.filter((_) => {
            if (_.sizeId == temp2[___.code].selectedSizeId) {
              temp2[___.code]["defaultSizeName"] = _.name;
              temp2[___.code]["sizeName"] = _.name;
              temp2[___.code]["sizeId"] = temp2[___.code].selectedSizeId;
            }
            return _.sizeId == temp2[___.code].selectedSizeId;
          })[0]?.price;
        temp2[___.code]["itemPrice"] = temp2[___.code]["defaultPrice"];
      }
      temp2[___.code]["itemPrice"] = temp2[___.code]["defaultPrice"];
      temp2[___.code]["addTopngs"] = [];

      if (Object.keys(priceHashCode[___.code]) == 0) {
        delete priceHashCode[___.code];
      }
    });
    response[__.categoryName] = { ...__, data: temp2 };
  });

  return { response: response, priceHashCode: priceHashCode };
};

const getCurrentToppingsTotalPrice = (toppingsMasterData, item) => {
  let sum = 0;
  item.addTopngs?.map((_) => {
    sum =
      sum +
        +toppingsMasterData.filter((__) => {
          return __.toppingId == _;
        })[0]?.price[item.sizeId] || 0;
  });
  return sum;
};

// const sendToLoginScreen = (location) => {
//   localStorage.finalRedirectUrl = location.href;
//   window.location.href = v2PwaBasePath + "/login?redirectUrl=" + location.href;
//   return;
// };

const getAppDownloadLink = () => {
  return "https://dominos.onelink.me/uM7R/3e839899";
};

const getCurrentStoreFolder = () => {
  let _ = window.location.href.split(projectBasePathWithFolder + "/")[1];
  if (_?.startsWith("?")) _ = "store";
  else {
    _ = _?.split("/")[0]?.split("?")[0] || "store";
  }

  return `/${_}/`;
};

const scrollUptoTo = (elmId) => {
  let el = document.getElementById(elmId);
  let top = el?.offsetTop;

  window.scrollTo({
    top: top - 10,
    left: 100,
    behavior: "smooth",
  });
};

const getToppingPriceForSize = (toppingsArray, toppingId, sizeId) => {
  let _ = 0;
  for (let i = 0; i < toppingsArray.length; i++) {
    if (toppingsArray[i].toppingId == toppingId) {
      _ = +toppingsArray[i].price[sizeId];
      break;
    }
  }
  return _;
};

const toppingsNameByToppingId = (mainArry, allTopngs, data) => {
  let currentToppingsName = [];
  if (mainArry?.length > 0 && data?.length > 0) {
    currentToppingsName = mainArry.filter((i) => {
      if (data.sort().toString() == i.addTopngs.sort().toString()) {
        return i;
      }
    });
  }
  let obj = currentToppingsName[0] || [];
  if (obj.addTopngs) {
    let newObj = obj.addTopngs.map((i) => Number(i));
    return allTopngs
      .filter((j) => newObj.includes(Number(j.toppingId)))
      .map((o) => o.name)
      .join();
  } else {
    return "";
  }
};

const currentCrustName = (arry, result) => {
  // arry = it is current CartItems from store
  // result = it is current selected item which will going to add or sub
  let ary = [];
  if (arry && result) {
    ary = arry.filter((i) => i.crustName == result.crustName);
  }
  return ary[0]?.crustName || "";
};

const currentSizeName = (arry, result) => {
  // arry = it is current CartItems from store
  // result = it is current selected item which will going to add or sub
  let name = [];
  if (arry && result) {
    name = arry.filter((i) => i.sizeName == result.sizeName);
  }
  return name[0]?.sizeName || "";
};

const deepCopyArry = (data) => {
  return JSON.parse(JSON.stringify(data));
};
const sortQniqueArry = (data) => {
  return Array.from(new Set(data.map(JSON.stringify))).map(JSON.parse);
};

const getWidgetWidthHeight = (
  itemsInScreen = 1.75,
  aspectRatio = 1,
  gap = 28,
  minWidth = 300
) => {
  let width = (window.innerWidth - gap) / itemsInScreen;
  let height = width / (aspectRatio + gap);
  return {
    width: width >= minWidth ? width : minWidth,
    height: height,
  };
};

const amplitudeEventObj = (
  userAction,
  sectionName,
  sectionPosition,
  preObj
) => {
  return {
    userAction,
    sectionName,
    sectionPosition,
    ...(preObj.positionWithinSection && {
      positionWithinSection: preObj.positionWithinSection,
    }),
    ...(preObj.category && { category: preObj.category }),
    ...(preObj.subCategory && { subCategory: preObj.subCategory }),
    ...(preObj.orderType && { orderType: preObj.orderType }),
    ...(preObj.searchSection && { searchSection: preObj.searchSection }),
    ...(preObj.searchQuery && { searchQuery: preObj.searchQuery }),
    ...(preObj.categoryPosition && {
      categoryPosition: preObj.categoryPosition,
    }),
    ...(preObj.offerType && { offerType: preObj.offerType }),
    ...(preObj.milestoneStage && { milestoneStage: preObj.milestoneStage }),
    ...(preObj.offerStage && { offerStage: preObj.offerStage }),
    ...(preObj.impressionType && { impressionType: preObj.impressionType }),
    ...(preObj.scrollType && { scrollType: preObj.scrollType }),
    ...(preObj.enrollmentStatus && {
      enrollmentStatus: preObj.enrollmentStatus,
    }),
    ...(preObj.points && { points: preObj.points }),
    ...(preObj.loginStatus && { loginStatus: preObj.loginStatus }),
    ...(preObj.actionType && { actionType: preObj.actionType }),
    ...(preObj.addToCart && { addToCart: preObj.addToCart }),
    ...(preObj.sellerType && { sellerType: preObj.sellerType }),
    ...(preObj.popularityType && { popularityType: preObj.popularityType }),
    ...(preObj.addCounter && { addCounter: preObj.addCounter }),
    ...(preObj.addNonVegToppings && {
      addNonVegToppings: preObj.addNonVegToppings,
    }),
    ...(preObj.addVegToppings && { addVegToppings: preObj.addVegToppings }),
    ...(preObj.changeCrust && { changeCrust: preObj.changeCrust }),
    ...(preObj.changeSize && { changeSize: preObj.changeSize }),
    ...(preObj.close && { close: preObj.close }),
    ...(preObj.entry && { entry: preObj.entry }),
    ...(preObj.replaceToppings && { replaceToppings: preObj.replaceToppings }),
    ...(preObj.replaceToppingsFrom && {
      replaceToppingsFrom: preObj.replaceToppingsFrom,
    }),
    ...(preObj.replaceToppingsTo && {
      replaceToppingsTo: preObj.replaceToppingsTo,
    }),
    ...(preObj.add && { add: preObj.add }),
    ...(preObj.resetAll && { resetAll: preObj.resetAll }),
    ...(preObj.update && { update: preObj.update }),
    ...(preObj.resultCount && { resultCount: preObj.resultCount }),
    ...(preObj.topResult && { topResult: preObj.topResult }),
    Page_Name: preObj.screenName ? preObj.screenName : "homepage",
    previousScreenname: preObj.previousScreenname
      ? preObj.previousScreenname
      : document.referrer,
  };
};

const returnsGetItemWQuantity = (cartData, addItemToCart) => {
  let item = [];
  if (cartData) {
    item = cartData.find((i) => i.code == addItemToCart.code);
  }
  if (item) {
    return true;
  } else {
    return false;
  }
};

const jsonParser = (json, defaultVal = {}) => {
  try {
    if (typeof json === "object" || !json) return json;
    return JSON.parse(json);
  } catch (e) {
    return defaultVal;
  }
};

const getSessionStorageValue = (key) => {
  try {
    if (typeof window !== "undefined") {
      return jsonParser(sessionStorage.getItem(key));
    }
  } catch (err) {}
};

const replaceToppingText = (cartData, allTopngs, data) => {
  let replaceTopDisplay = "";
  if (cartData.length > 0 && cartData?.length !== undefined) {
    const curObj = cartData[cartData.length - 1];
    const { remTopngs, repTopngs } = curObj;
    if (remTopngs && repTopngs) {
      let removeTop = allTopngs.find(
        (i) => Number(i.toppingId) === Number(curObj["remTopngs"][0])
      );
      let addTop = allTopngs.find(
        (i) => Number(i.toppingId) === Number(curObj["repTopngs"][0])
      );
      if (removeTop && addTop) {
        replaceTopDisplay = `${removeTop.name} with ${addTop.name}` || "";
      }
    }
  }
  if (data?.repTopngs?.length !== undefined && data?.repTopngs?.length > 0) {
    return replaceTopDisplay;
  } else {
    return "";
  }
};

const defaultToppingsCustomAtrrArry = (
  currentItemDefaultTopping,
  allTopngs
) => {
  if (currentItemDefaultTopping && allTopngs) {
    return allTopngs
      .filter((item) => currentItemDefaultTopping.includes(item.toppingId))
      .map((i) => i.custAttrField);
  }
};

const getAddressAlias = (
  coords = LocalStorageFunc.getLastLocationNewOrLastLocationNewForIp()[0]
    ?.location || ""
) => {
  let footerAddress =
    LocalStorageFunc.getLastLocationNewOrLastLocationNewForIp()[0]?.recent
      ?.footerAddress ||
    LocalStorageFunc.getLastLocationNewOrLastLocationNewForIp()[0]?.recent
      ?.city ||
    "";
  if (LocalStorageFunc.getLocationSource() == "ip") {
    return (
      LocalStorageFunc.getLastLocationNewOrLastLocationNewForIp()[0]?.recent
        ?.city || ""
    );
  }
  let deliveryType = LocalStorageFunc.getDeliveryType();
  if (deliveryType == "P") {
    return "Takeaway from";
  } else if (deliveryType == "DINEIN") {
    return "Dine-in at";
  } else {
    let userAddresses = localStorage.userAddresses
      ? tryJsonParse(localStorage.userAddresses)
      : "";
    try {
      for (const item of userAddresses) {
        if (
          item.longitude == coords.longitude &&
          item.latitude == coords.latitude
        ) {
          return (
            item.customer_address_name ||
            "Home" ||
            item.footerAddress ||
            item.city
          );
        }
      }
    } catch (err) {}
    return footerAddress;
  }
};

const findOrdinalsSufixInDate = (day) => {
  // it will set the appropriate string according to day
  let first = Number(day) % 10;
  let second = Number(day) % 100;
  if (first == 1 && second != 11) {
    return "st";
  }
  if (first == 2 && second != 12) {
    return "nd";
  }
  if (first == 3 && second != 13) {
    return "rd";
  }
  return "th";
};

const getNotAvailablePizzaInStore = (storeItem, currentPizza) => {
  let isAva = [];
  if (currentPizza !== undefined && storeItem?.length !== undefined) {
    isAva = storeItem.find((i) => i.code === currentPizza.menuCode);
  }
  if (isAva && Object.keys(isAva)?.length > 0) {
    return false;
  } else {
    return true;
  }
};

const getDomain = () => {
  let domain = window.location.host.toString();
  let index = domain.indexOf(".");
  domain = domain.substr(index, domain.length - 1);
  return domain;
};

const setCookie = (name, value, days, domain) => {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie =
    name +
    "=" +
    (value || "") +
    ";domain=" +
    (domain || ".dominos.co.in") +
    expires +
    "; path=/";
};

const getCookie = (c_name) => {
  var i,
    x,
    y,
    ARRcookies = document.cookie.split(";");
  for (i = 0; i < ARRcookies.length; i++) {
    x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
    y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
    x = x.replace(/^\s+|\s+$/g, "");
    if (x == c_name) {
      return unescape(y);
    }
  }
};

const deleteCookie = (name, domain) => {
  if (name) {
    document.cookie =
      name +
      "=;expires=Thu,01 Jan 1970 00:00:01 UTC;path=/;domain=" +
      (domain || ".dominos.co.in");
  }
};

const addKeyToCartWhenReloadsData = (arr) => {
  if (arr) {
    return arr.map((i) => {
      if (
        (i?.addTopngs?.length !== undefined && i?.addTopngs?.length > 0) ||
        i.defaultSizeName !== i.sizeName ||
        i.defaultCrustName !== i.crustName
      ) {
        return { ...i, isUserCustomizable: true };
      } else {
        return { ...i, isUserCustomizable: false };
      }
    });
  } else {
    return [];
  }
};

const getUrlQueryString = () => {
  let _ = "";
  try {
    var url = window.location.href,
      retObject = {},
      parameters;
    if (url.indexOf("?") === -1) {
      return "";
    }
    url = url.split("?")[1];
    parameters = url.split("&");
    for (var i = 0; i < parameters.length; i++) {
      retObject[parameters[i].split("=")[0]] = parameters[i].split("=")[1];
    }

    _ = "?";
    for (const [key, value] of Object.entries(retObject)) {
      if (key) {
        _ = _ + "&" + key + "=" + value;
      }
    }
  } catch (e) {
    _ = "";
  }

  return _;
};

const getQueryFromUrl = (url = window.location.href) => {
  var retObject = {};
  try {
    var parameters;
    if (url.indexOf("?") === -1) {
      return {};
    }
    url = url.split("?")[1];
    parameters = url.split("&");
    for (var i = 0; i < parameters.length; i++) {
      retObject[parameters[i].split("=")[0]] = parameters[i].split("=")[1];
    }
  } catch (e) {
    return {};
  }

  return retObject;
};

const checkWindowLocationIncludes = (partial) => {
  return (
    window.location.href.includes(partial) &&
    (window.location.href.includes(partial + "/") ||
      window.location.href.includes(partial + "?") ||
      !window.location.href.split(partial)[1])
  );
};

const isAddressAvailable = (addressList, recentLocation, recentStoreCoord) => {
  let matchAddress = getPreSelectedAddress(addressList, recentStoreCoord);
  if (!matchAddress) {
    matchAddress = getPreSelectedAddress(addressList, recentLocation);
  }
  return matchAddress;
};

export const getPreSelectedAddress = (addressList, lastLocation) => {
  let addressMatch = false;
  for (let i = 0; i < addressList.length; i++) {
    const address = addressList[i];
    if (address.address_id === lastLocation.address_id) {
      addressMatch = address;
      break;
    }
  }
  if (!addressMatch) {
    for (let i = 0; i < addressList.length; i++) {
      const address = addressList[i];
      const currLatitude = parseFloat(get(address, "latitude", 0)).toFixed(3);
      const lastLatitude = parseFloat(get(lastLocation, "latitude", 0)).toFixed(
        3
      );
      const currLongitude = parseFloat(get(address, "longitude", 0)).toFixed(3);
      const lastLongitude = parseFloat(
        get(lastLocation, "longitude", 0)
      ).toFixed(3);
      const locationAddress = {
        city: address.city || " ",
        locality: address.city_region || " ",
        sub_locality: address.area_level0 || " ",
        area1: address.area_level1 || " ",
        area2: address.area_level2 || " ",
      };
      const locationObj = {
        city: lastLocation.city || " ",
        locality: lastLocation.locality || " ",
        sub_locality: lastLocation.sub_locality || " ",
        area1: lastLocation.area1 || " ",
        area2: lastLocation.area2 || " ",
      };
      if (
        currLatitude != 0.0 &&
        currLatitude === lastLatitude &&
        currLongitude != 0.0 &&
        currLongitude === lastLongitude
      ) {
        addressMatch = address;
        break;
      } else if (isEqual(locationAddress, locationObj)) {
        addressMatch = address;
        break;
      }
    }
  }

  return addressMatch;
};

// time will be in milliseconds
const convertEpochToDate = (time) => new Date(time);
const getDateFromEpoch = (time) => convertEpochToDate(time).getDate();
const getMonthFromEpoch = (time) =>
  convertEpochToDate(time).toLocaleString("en-us", { month: "short" });

const getNextDayDate = () => {
  const nextDay = new Date();
  nextDay.setDate(nextDay.getDate() + 1);
  return nextDay.getDate();
};

const getAdvanceDateFromEpoch = (time) => {
  let day = convertEpochToDate(time).getDate();
  day = day < 10 ? `0${day}` : day;
  return day;
};

const getAdvanceDateMonth = (time) => {
  if (new Date().getDate() === getDateFromEpoch(time)) {
    return "Today";
  }
  if (getNextDayDate() === getDateFromEpoch(time)) {
    return "Tomorrow";
  }
  return `${getAdvanceDateFromEpoch(time)} ${getMonthFromEpoch(time)}`;
};

const formatAMPM = (time) => {
  const date = convertEpochToDate(time);
  let hours = date.getHours();
  let minutes = date.getMinutes();
  const ampm = hours >= 12 ? "pm" : "am";
  hours %= 12;
  hours = hours || 12;
  minutes = minutes < 10 ? `0${minutes}` : minutes;
  hours = +hours < 10 ? `0${hours}` : hours;
  const strTime = `${hours}:${minutes} ${ampm.toUpperCase()}`;
  return strTime;
};

const groupCartItems = (cartItems) => {
  const finalList = [];
  const edvItems = {};
  let key;
  cartItems.forEach((item) => {
    if (
      item.isEDVOApplied ||
      get(item, "promoPerQty[0].promoType", "") === "DEAL_EXPLICIT"
    ) {
      item.promoPerQty.forEach((promo) => {
        key = promo.promoGroupid;
        edvItems[key] = edvItems[key] || [];
        edvItems[key].push(item);
      });
    } else finalList.push([item]);
  });
  Object.keys(edvItems).forEach((item) => finalList.push(edvItems[item]));
  return finalList;
};

const edvMixMatchDataPrice = (cartData) => {
  try {
    const edvMixMatchPrice = [];
    const edvMixMatchData = [];
    const crtItmGrp = groupCartItems(cartData);
    const edvDealIds = [];
    const edvSameSizeIds = [];
    let anotherItemPresent = false;
    let edvCount = 0;
    const sameEdvDealId = null;
    let sameSizeId = null;
    let edvItemsInCart = false;

    crtItmGrp.forEach((grp) => {
      if (grp.length > 1) {
        edvCount += 1;
        const prc = [];
        let sameEdvDealId = null;
        grp.forEach((item) => {
          if (
            item.isEDVOApplied ||
            get(item, "promoPerQty[0].promoType", "") === "DEAL_EXPLICIT"
          ) {
            edvItemsInCart = true;
            const itemDealId = get(item, "promoPerQty[0].id", null);
            const itemSizeId = get(item, "size.id", null);

            prc.push(
              `EDV${edvCount}-${
                item.totalPriceAfterDiscount ||
                item.pricePerQty - item.totalDiscount
              }`
            );

            if (!sameEdvDealId) {
              sameEdvDealId = itemDealId;
            } else {
              sameEdvDealId = sameEdvDealId === itemDealId;
            }

            if (!sameSizeId) {
              sameSizeId = itemSizeId;
            } else {
              sameSizeId = sameSizeId === itemSizeId;
            }
          }
        });
        edvMixMatchPrice.push(prc.join("|"));
        edvDealIds.push(`EDV${edvCount}-${!sameEdvDealId ? "Yes" : "No"}`);
        edvSameSizeIds.push(`EDV${edvCount}-${!sameSizeId ? "Yes" : "No"}`);
      } else {
        anotherItemPresent = true;
      }
    });

    if (!edvItemsInCart) return null; // if no edv item present in cart

    const mm = `M&M-${getLocalStorageValueV2(LOCAL_STORAGE_KEYS.EDV_MM)}`;
    const pm = `PM-${anotherItemPresent ? "Yes" : "No"}`;

    edvMixMatchData.push(mm);
    edvMixMatchData.push(pm);
    edvMixMatchData.push(`BM-${edvDealIds.join(",")}`);
    edvMixMatchData.push(`SM-${edvSameSizeIds.join(",")}`);

    return {
      edvMixMatchData,
      edvMixMatchPrice,
      edvItemsInCart,
    };
  } catch (err) {
    console.error("Error in edvMixMatchDataPrice", err);
    return { edvMixMatchData: [], edvMixMatchPrice: [] };
  }
};

const getPriceToBePaid = (data) => {
  const strikePrice = get(data, "globalData.strikePrice", undefined);
  const displayPrice = get(data, "globalData.displayPrice", 0);
  const priceToBePaid = !["undefined", "null", undefined, null].includes(
    typeof strikePrice
  )
    ? strikePrice
    : displayPrice;
  return priceToBePaid;
};

const getPaymentId = (paymentMode) => {
  let paymentId;
  if (paymentMode.cardId) {
    //TBD - case of saved cards
    paymentId = "CC";
  } else {
    paymentId = paymentMode.paymentId;
  }
  return paymentId;
};

const getPaymentMode = (paymentModeObj) => {
  let paymentMode;
  if (paymentModeObj.cardId) {
    //TBD - case of saved cards
    paymentMode = "CC";
  } else {
    paymentMode = paymentModeObj.paymentMode;
  }
  return paymentMode;
};

const setStoreAndLocation = (response) => {
  LocalStorageFunc.setStoreId(
    get(
      response,
      "confirmOrderBatchResponse.storeDetails.id",
      LocalStorageFunc.getStoreId()
    )
  );
};
/**
 * sends a request to the specified url from a form. this will change the window location.
 * @param {string} path the path to send the post request to
 * @param {object} params the parameters to add to the url
 * @param {string} [method=post] the method to use on the form
 */

const postFormData = (path, params, method = "post") => {
  const form = document.createElement("form");
  form.method = method;
  form.action = path;
  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      const hiddenField = document.createElement("input");
      hiddenField.type = "hidden";
      hiddenField.name = key;
      hiddenField.value = params[key];

      form.appendChild(hiddenField);
    }
  }
  document.body.appendChild(form);
  form.submit();
};

const checkIfPlatformIsAndroid = () => {
  const userAgent =
    !!navigator && (navigator.userAgent || navigator.vendor || window.opera);
  const isPlatformAndroid = /android/i.test(userAgent);
  return isPlatformAndroid;
};

// Mini App
const getMiniAppStorageVal = () => LocalStorageFunc.getIsMiniApp();
const checkIfIsMiniApp = (miniApp = getMiniAppStorageVal()) =>
  [MINIAPP.GPAY, MINIAPP.PAYTM].includes(miniApp || "");
const checkIfIsGpay = (miniApp = getMiniAppStorageVal()) =>
  miniApp === MINIAPP.GPAY;
const checkIfIsPAYTM = (miniApp = getMiniAppStorageVal()) =>
  miniApp === MINIAPP.PAYTM;

const cssAccordionTransistion = (
  state,
  expandHeight,
  compressHeight,
  doc,
  id
) => {
  // apply transition on accordion
  const myElement = doc !== null ? doc : document.getElementById(id);
  myElement && applyAccordTr(myElement);

  if (myElement !== null) {
    if (state) {
      myElement.style.height = expandHeight;
    } else {
      myElement.style.height = compressHeight;
    }
  } else {
    if (myElement !== null) {
      myElement.style.height = state ? expandHeight : compressHeight;
    }
  }
};

const applyAccordTr = (doc) => {
  // trasition delay
  if (doc) {
    doc.style.transition = "height 250ms";
    doc.style.transitionTimingFunction = "ease-out";
  }
};

const getTotalWalletBalance = (cartData) => {
  let totalBalance = 0;
  if (cartData.walletDetails && cartData.walletDetails.balance) {
    totalBalance = cartData.walletDetails.balance;
  }
  return totalBalance;
};

const saveCartSuccess = (payload) => {
  localStorage.cartData = JSON.stringify(payload);
  // localStorage.cartItems = JSON.stringify(get(payload, "validItems", []));   //todo: for nextgen cart this is different object structure and hence commented
  localStorage.displayNetPrice = get(payload, "strikePrice", "");
};

const toLower = (string = "") => (string.length ? string.toLowerCase() : "");

const preprocessRecommendedData = (apiData, visibleCount) => {
  let recommendedData = [];
  if (apiData.length > 0) {
    let tempData = apiData.slice(0, visibleCount);
    let i = 0,
      currentCount = 0;
    do {
      if (tempData[i]) {
        if (
          tempData[i].paymentMode == "CC" ||
          tempData[i].paymentMode == "DC"
        ) {
          if (tempData[i].savedCards?.length > 0) {
            let tempCC = deepCopyArry(tempData[i]);
            tempCC.savedCards = [];
            recommendedData.push(tempCC);
            for (let j = 0; j < tempData[i].savedCards.length; j++) {
              recommendedData[i].savedCards.push(tempData[i].savedCards[j]);
              currentCount++;
              if (currentCount >= visibleCount) break;
            }
          }
          i++;
        } else {
          recommendedData.push(tempData[i]);
          i++;
          currentCount++;
        }
      }
      currentCount++;
    } while (currentCount < visibleCount || i < visibleCount);
  }
  return recommendedData;
};

const checkCrustSizeId = (data) => {
  const values = data;
  try {
    values.forEach((element) => {
      element.crustId = !element.crustId
        ? get(element, "crust.id", "")
        : element.crustId;
      element.sizeId = !element.sizeId
        ? get(element, "size.id", "")
        : element.sizeId;
    });
    return values;
  } catch (err) {
    return data;
  }
};

const isEmpty = (obj) =>
  [Object, Array].includes((obj || {}).constructor) &&
  !Object.entries(obj || {}).length;

/**
 * @returns Promise<"denied" | "granted" | "prompt" | "not_available">
 */
const checkLocationPermission = () =>
  (navigator.permissions &&
    navigator.permissions
      .query({ name: "geolocation" })
      .then((PermissionStatus) => PermissionStatus.state)) ||
  Promise.resolve("not_available");

const checkGAIDForUPIIntent = (abTestConfig) =>
  get(abTestConfig, "upi_intentflow_ab", "") === "intent";
const checkIfShouldShouldShowUPIIntent = (abTestConfig) =>
  checkIfPlatformIsAndroid() && checkGAIDForUPIIntent(abTestConfig);

const deliveryTipAmountSelector = (cartData) => {
  const tipAmount = get(cartData, "tips.amount", null);
  const validCartItems = get(
    cartData,
    "validItems",
    LocalStorageFunc.getCartItems()
  );
  const invalidCartItems = get(cartData, "invalidItems", []);
  if (validCartItems.length <= 0 && invalidCartItems.length <= 0) {
    return 0;
  }
  return tipAmount;
};

// const getAmplitudeAttributes = () => {
//   const amplitudeClient = getAmplitudeInstance() || {};
//   const { options: ampOptions = {}, _ua: osDetails = {} } =
//     amplitudeClient || {};
//   const { platform } = ampOptions;
//   const { os } = osDetails;
//   const ampUserId = amplitudeClient.getUserId?.();
//   const ampDeviceId = amplitudeClient.getDeviceId?.();
//   const ampSessionId = amplitudeClient.getSessionId?.();
//   return {
//     amp_user_id: ampUserId,
//     amp_device_id: ampDeviceId,
//     amp_session_id: ampSessionId,
//     amp_platform: platform,
//     amp_os_name: os?.name
//   };
// };

const zeroContactSelector = (deliveryType, appConfigFromStore) => {
  return deliveryType === ORDER_TYPE.DELIVERY
    ? noContactDeliverySelector(appConfigFromStore)
    : noContactPickupSelector(appConfigFromStore);
};

const noContactDeliverySelector = (appConfig) => {
  const { config } = appConfig;
  return get(config, "noContactDeliveryCV4", {});
};

const noContactPickupSelector = (appConfig) => {
  const { config } = appConfig;
  return get(config, "noContactPickupCV4", {});
};

const getCardText = (cardType) => {
  switch (cardType.toUpperCase()) {
    case "CREDIT":
    case "CC":
      return "Credit Card";
      break;
    case "DEBIT":
    case "DC":
      return "Debit Card";
      break;
    default:
      return "";
      break;
  }
};

const displayCardNumber = (cardNumber) => {
  return `xxxx ${String(cardNumber).slice(
    cardNumber.length - 4,
    cardNumber.length
  )}`
}
const iconShown = (cardType) => {
  switch (cardType.toUpperCase()) {
    case "VISA":
      return "jfi-bankicon-visa";
      break;
    case "MX":
      return "jfi-bankicon-mx";
      break;
    case "AMEX":
      return "jfi-bankicon-mx";
      break;
    case "MASTER":
      return "jfi-bankicon-master_card";
      break;
    case "MAESTRO":
      return "jfi-bankicon-mestro";
      break;
    case "RUPAY":
      return "jfi-bankicon-rupay";
      break;
    default:
      return "jfi-bankicon-blankicon";
      break;
  }
};

const getIconImgUsingPaymentId = (pymtId) => {
  switch (pymtId) {
    case "CASH":
      return "jfi-cash mt4";
      break;

    case "CC":
      return "jfi-bankicon-plusicon";
      break;

    case "DC":
      return "jfi-bankicon-plusicon";
      break;

    case "HDFC_NB":
      return "HDFC_NB";
      break;

    case "IDB_NB":
      return "IDB_NB";
      break;

    case "IDFC_NB":
      return "IDFC_NB";
      break;

    case "ICICI_NB":
      return "ICICI_NB";
      break;

    case "SBI_NB":
      return "SBI_NB";
      break;

    case "AXIS_NB":
      return "AXIS_NB";
      break;

    case "KOTAK_NB":
      return "KOTAK_NB";
      break;

    case "YBK_NB":
      return "YBK_NB";
      break;

    case "EVOUCHER":
      return "EVOUCHER mt4";
      break;

    case "AMAZON_UPI_WALLET":
      return "AMAZON_UPI_WALLET";
      break;

    case "PAYTM_WALLET":
      return "PAYTM_WALLET";
      break;

    case "UPI_WALLET":
      return "UPI_WALLET";
      break;

    case "MBK_CASHCRD":
      return "MBK_CASHCRD";
      break;

    case "FREC_CASHCRD":
      return "FREC_CASHCRD";
      break;

    case "PZ1_CASHCRD":
      return "PZ1_CASHCRD";
      break;

    case "ATL_CASHCRD":
      return "ATL_CASHCRD";
      break;

    case "OXY_CASHCRD":
      return "OXY_CASHCRD";
      break;

    case "PIGGYBANK":
      return "jfi-wallet";
      break;

    case "PHONEPE_UPI_WALLET":
      return "jfi-bankicon-Phone_Pe";
      break;

    case "RJM_CASHCRD":
      return "jfi-bankicon-jio_money";
      break;

    default:
      return "jfi-bankicon-blankicon";
      break;
  }
};

const wantToDisabledToAllScreenForSubmit = (id) => {
  // let disabledAllOnSubmitClicked = document.getElementById("themeDefaultPayment")
  // let classText = "payment-view "
  // if(id && typeof id == "boolean") {
  //   classText = "payment-view disabled-class-for-submit-order"
  // } else {
  //   classText = "payment-view"
  // }
  // disabledAllOnSubmitClicked.className = classText;
};

const utcMilllisecondsSinceEpochFun = () => {
  let now = new Date().getTime();
  return now;
};

const getVwoPwaV2Variations = () => {
  try {
    return getSessionStorageValue("VWO_PWA_V2_VARIATIONS");
  } catch (e) {
    return "";
  }
};

const getQueryFromQueryParameters = (params) => {
  let paramKeys = Object.keys(params);
  let query = "";
  paramKeys.map((item, index) => {
    if (index !== paramKeys.length - 1 && params[item] !== undefined) {
      query = query + item + "=" + params[item] + "&";
    } else if (params[item] !== undefined) {
      query = query + item + "=" + params[item];
    }
  });
  return query;
};

const addQueryParams = (url) => {
  let currentUrl = window.location.href;
  let currentQueryParams = getQueryFromUrl(currentUrl);
  let queryParams = getQueryFromUrl(url);
  // in case both have query parameters
  if (currentUrl.indexOf("?") !== -1) {
    if (currentQueryParams["redirectUrl"]) {
      delete currentQueryParams["redirectUrl"];
    }
    let newQuery = getQueryFromQueryParameters(
      Object.assign({}, currentQueryParams, queryParams)
    );
    if (newQuery.length > 0) {
      return url.split("?")[0] + "?" + newQuery;
    } else {
      return url.split("?")[0];
    }
  } else {
    return url;
  }
};

const redirectToLinkRewrite = (
  linkRewrite,
  baseUrl = projectBasePathWithFolder
) => {
  store.commit(keyMapsMutation.UPDATE_LOADING_STATE, true, {
    root: true,
  });
  setTimeout(
    () =>
      store.commit(keyMapsMutation.UPDATE_LOADING_STATE, false, {
        root: true,
      }),
    5000
  );
  if (!window.location.pathname.includes(linkRewrite)) {
    let url = baseUrl + linkRewrite;
    window.location.href = addQueryParams(url);
  } else {
    window.location.reload();
  }
  return;
};

const sendToThankYouScreen = (transactionId = "") => {
  redirectToLinkRewrite(
    "/thankYou?transactionId=" + transactionId,
    projectBasePathWithFolder
  );
};

const getLandingPageVWOTest = () => {
  try {
    return getSessionStorageValue("VWO_HOME_VARIANT")?.toLowerCase();
  } catch (e) {
    return "";
  }
};

const getOrderHistroyVariant = () => {
  try {
    return getSessionStorageValue("VWO_ORDER_HISTORY_VARIANT");
  } catch (e) {
    return "";
  }
};

const getTipCartVariant = () => {
  try {
    return getSessionStorageValue("VWO_TIPCART_VARIANT");
  } catch (e) {
    return "";
  }
};

const getVWONextGenPayment = () => {
  try {
    return getSessionStorageValue(
      "VWO_NEXT_GEN_PAYMENT_VARIANT"
    )?.toLowerCase();
  } catch (e) {
    console.error("ERROR IN GETTING VWO NextGen PAYMENT VARIANT", e);
    return "";
  }
};

const Base64 = {
  _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
  encode: function (e) {
    var t = "";
    var n, r, i, s, o, u, a;
    var f = 0;
    e = Base64._utf8_encode(e);
    while (f < e.length) {
      n = e.charCodeAt(f++);
      r = e.charCodeAt(f++);
      i = e.charCodeAt(f++);
      s = n >> 2;
      o = ((n & 3) << 4) | (r >> 4);
      u = ((r & 15) << 2) | (i >> 6);
      a = i & 63;
      if (isNaN(r)) {
        u = a = 64;
      } else if (isNaN(i)) {
        a = 64;
      }
      t =
        t +
        this._keyStr.charAt(s) +
        this._keyStr.charAt(o) +
        this._keyStr.charAt(u) +
        this._keyStr.charAt(a);
    }
    return t;
  },
  decode: function (e) {
    var t = "";
    var n, r, i;
    var s, o, u, a;
    var f = 0;
    e = e.replace(/[^A-Za-z0-9\+\/\=]/g, "");
    while (f < e.length) {
      s = this._keyStr.indexOf(e.charAt(f++));
      o = this._keyStr.indexOf(e.charAt(f++));
      u = this._keyStr.indexOf(e.charAt(f++));
      a = this._keyStr.indexOf(e.charAt(f++));
      n = (s << 2) | (o >> 4);
      r = ((o & 15) << 4) | (u >> 2);
      i = ((u & 3) << 6) | a;
      t = t + String.fromCharCode(n);
      if (u != 64) {
        t = t + String.fromCharCode(r);
      }
      if (a != 64) {
        t = t + String.fromCharCode(i);
      }
    }
    t = Base64._utf8_decode(t);
    return t;
  },
  _utf8_encode: function (e) {
    e = e.replace(/\r\n/g, "\n");
    var t = "";
    for (var n = 0; n < e.length; n++) {
      var r = e.charCodeAt(n);
      if (r < 128) {
        t += String.fromCharCode(r);
      } else if (r > 127 && r < 2048) {
        t += String.fromCharCode((r >> 6) | 192);
        t += String.fromCharCode((r & 63) | 128);
      } else {
        t += String.fromCharCode((r >> 12) | 224);
        t += String.fromCharCode(((r >> 6) & 63) | 128);
        t += String.fromCharCode((r & 63) | 128);
      }
    }
    return t;
  },
  _utf8_decode: function (e) {
    var t = "";
    var n = 0;
    var r = (c1 = c2 = 0);
    while (n < e.length) {
      r = e.charCodeAt(n);
      if (r < 128) {
        t += String.fromCharCode(r);
        n++;
      } else if (r > 191 && r < 224) {
        c2 = e.charCodeAt(n + 1);
        t += String.fromCharCode(((r & 31) << 6) | (c2 & 63));
        n += 2;
      } else {
        c2 = e.charCodeAt(n + 1);
        c3 = e.charCodeAt(n + 2);
        t += String.fromCharCode(
          ((r & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63)
        );
        n += 3;
      }
    }
    return t;
  },
};

export default {
  //   pizzaCounter,
  randomnumber,
  tryJsonParse,
  calculateIsTrueLocationDetectedFromLocationSource,
  takeawayDineinFolder,
  deliveryFolder,
  keybasedProductItems,
  textLowerAndTrimSpace,
  keybasedProductItem,
  getCurrentToppingsTotalPrice,
  //   sendToLoginScreen,
  getAppDownloadLink,
  getCurrentStoreFolder,
  scrollUptoTo,
  deepCopyArry,
  sortQniqueArry,
  getToppingPriceForSize,
  getWidgetWidthHeight,
  toppingsNameByToppingId,
  amplitudeEventObj,
  currentCrustName,
  currentSizeName,
  returnsGetItemWQuantity,
  jsonParser,
  getSessionStorageValue,
  replaceToppingText,
  defaultToppingsCustomAtrrArry,
  getAddressAlias,
  findOrdinalsSufixInDate,
  getNotAvailablePizzaInStore,
  getDomain,
  setCookie,
  getCookie,
  deleteCookie,
  addKeyToCartWhenReloadsData,
  getUrlQueryString,
  getQueryFromUrl,
  checkWindowLocationIncludes,
  isAddressAvailable,
  getAdvanceDateMonth,
  formatAMPM,
  edvMixMatchDataPrice,
  getPriceToBePaid,
  getPaymentId,
  getPaymentMode,
  setStoreAndLocation,
  postFormData,
  checkIfPlatformIsAndroid,
  getMiniAppStorageVal,
  checkIfIsMiniApp,
  checkIfIsGpay,
  checkIfIsPAYTM,
  cssAccordionTransistion,
  applyAccordTr,
  getTotalWalletBalance,
  saveCartSuccess,
  toLower,
  preprocessRecommendedData,
  checkCrustSizeId,
  isEmpty,
  checkLocationPermission,
  checkIfShouldShouldShowUPIIntent,
  deliveryTipAmountSelector,
  //   getAmplitudeAttributes,
  zeroContactSelector,
  getIconImgUsingPaymentId,
  redirectToLinkRewrite,
  iconShown,
  wantToDisabledToAllScreenForSubmit,
  utcMilllisecondsSinceEpochFun,
  getVwoPwaV2Variations,
  getLandingPageVWOTest,
  getOrderHistroyVariant,
  getTipCartVariant,
  getVWONextGenPayment,
  sendToThankYouScreen,
  getCardText,
  displayCardNumber
  //   Base64
};
